import { LOG_INFO, logClientInfo } from 'src/common/actions/logging';

const logInfo = (middlewareApi) => (next) => (action) => {
  if (action.type === LOG_INFO) {
    middlewareApi.dispatch(
      logClientInfo({
        ...action.data,
        context: {
          ...action.data.context,
          pagePath: window.location.pathname,
        },
      }),
    );
  }

  next(action);
};

export default logInfo;
